import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SdkBase } from '../utilities/sdk-base/sdk.base';

@Injectable({
	providedIn: 'root'
})
export class CaseDashboardSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getCaseDashboardYears(): Observable<{ masterDate: string, masterDateCount: number }[]> {
		return this.makeHttpRequest('get', 'api2/case-dashboard/years')
	}

	public getCaseDashboardData(year: string): Observable<Array<Array<string>>> {
		return this.makeHttpRequest('post', 'api2/case-dashboard/data', { year });
	}
}
